function lookup(key) {
  const parts = String(key || "").split(".");
  let value = window.acvireTranslations || {};

  for (const part of parts) {
    if (!value || typeof value !== "object" || !Object.prototype.hasOwnProperty.call(value, part)) {
      return undefined;
    }
    value = value[part];
  }

  return value;
}

function interpolate(text, params = {}) {
  return String(text).replace(/%\{([A-Za-z0-9_]+)\}/g, (match, name) => (
    Object.prototype.hasOwnProperty.call(params, name) ? params[name] : match
  ));
}

function t(key, params = {}, fallback = key) {
  const value = lookup(key);
  return interpolate(typeof value === "string" ? value : fallback, params);
}

window.acvireT = t;

export default t;
